export const Color = {
  componentColor: {
    FooterContainer: "#757575",
    BorderGray: "#eee",
    ButtonBlue: "#08b9de",
  },
};
